import {useState, useEffect, useCallback} from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import axios from "axios";
import "./../../styles/admin/LessonPage.css"; 
import BASE_URL from "../../BaseUrl";

export default function LessonPage({setActive,setMobileActive}) {
  const location = useLocation();
  const navigate = useNavigate();
  const {id} = useParams();
  const [lesson, setLesson] = useState({});
  const [loaded , setLoaded] = useState(false);
  const [reload, setReload] = useState(false);
  const [isOldCodes, setIsOldCodes] = useState(true);
  const [getCodes, setGetCodes] = useState(false);
  const courseId = location.state? location.state.courseId: "";
  const adminId = location.state? location.state.adminId: "";
  const [warning, setWarngin] = useState("error");
  const [showWarning, setShowWarning] =useState(false);
  const [codesToGenerate,setCodesToGenerate] = useState(0);
  const [showCodesPopup, setShowCodePopup] = useState(false);
  const [showQRPopup, setShowQRPopup] = useState(false);
  const [capacityExceeded, setCapacityExceeded] = useState(false);

  const [lessonToEdit, setLessonToEdit] = useState({
        lessonId:id,
        lessonName:"",
        price: 0.00,
    })
    
  const [showDeleteLessonForm, setShowDeleteLessonForm] = useState(false);
  const [showEditLessonFrom,setShowEditLessonFrom] = useState(false)



  function deleteLesson(){
    axios.delete(`${BASE_URL}/teacher/delete-object?id=${lessonToEdit.lessonId}&type=lesson&courseId=${courseId}&adminId=${adminId}`, {withCredentials: true})
        .then((response)=>{
            setShowDeleteLessonForm(false);
            navigate(-1);
        }).catch((error)=>{
            console.log(error);
            setShowDeleteLessonForm(false);
        })
  }

  const updateLesson = ()=>{

          axios.put(`${BASE_URL}/teacher/update-lesson`,lessonToEdit,{withCredentials: true})
          .then((response)=>{
              setLessonToEdit({
                lessonId:id,
                lessonName:"",
                price: 0.00
              })
              setShowEditLessonFrom(false);
              setReload(!reload);
          }).catch((error)=>{
              console.log(error);
          })
      }

  async function downloadCodes (){
    const doc = new jsPDF();
    if(codesToGenerate <= 0) return;
    setGetCodes(true);
    try{
      const respons = await axios.get(`${BASE_URL}/teacher/code?lessonId=${id}&number=${codesToGenerate}&isQR=0`,{withCredentials:true});
      // doc.text(respons.data.join("\n"),10,10);
      const margin = 10;
      const pageHeight = doc.internal.pageSize.height;
      const lineHeight = 7;

      let y = margin;

      respons.data.forEach(item => {
        if (y + lineHeight > pageHeight - margin) {
          doc.addPage();
          y = margin;
        }

        doc.text(item, margin, y);
        y += lineHeight;
      });

      doc.save(`${lesson.lessonName}.pdf`);
      setGetCodes(false);
      setShowCodePopup(false);
    } catch(error){
      if(error.response.status === 401){
        setCapacityExceeded(true);
        setGetCodes(false);
        setShowCodePopup(false);
      }
    }
  }
  // get new codes for QR
  async function getListOfCodes(){
    const respons = await axios.get(`${BASE_URL}/teacher/code?lessonId=${id}&number=${codesToGenerate}&isQR=1`,{withCredentials:true});
    return respons.data;
  }

  async function getListOfOldCodes(){
    try{
      const respons = await axios.get(`${BASE_URL}/teacher/unused-codes?lessonId=${id}&isQR=1`,{withCredentials:true});
      if(respons.data.length === 0) {
        return [];
      }
      return respons.data;
    } catch(error){
      console.log(error);
    }
  }

  async function downloadUnusedCodes (){
    const doc = new jsPDF();
    setGetCodes(true);
    try{
      const respons = await axios.get(`${BASE_URL}/teacher/unused-codes?lessonId=${id}&isQR=0`,{withCredentials:true});
      if(respons.data.length === 0) {
        setIsOldCodes(false);
        setGetCodes(false);
        return;
      }
      const margin = 10;
      const pageHeight = doc.internal.pageSize.height;
      const lineHeight = 7;

      let y = margin;

      respons.data.forEach(item => {
        if (y + lineHeight > pageHeight - margin) {
          doc.addPage();
          y = margin;
        }

        doc.text(item, margin, y);
        y += lineHeight;
      });

      doc.save(` غير مستخدم${lesson.lessonName}.pdf`);
      setGetCodes(false);
    } catch(error){
      console.log(error);
    }
  }

  const fetchData = useCallback(()=>{
    if(id === null || id === "" || courseId === null || courseId === ""){
        navigate("/admin-home");
    }
    axios.get(`${BASE_URL}/teacher/lesson?lessonId=${id}&courseId=${courseId}`,{withCredentials: true})
    .then((response)=>{
        setLesson(response.data);
        setLessonToEdit({...lessonToEdit, lessonName: response.data.lessonName, price: response.data.price});
        setLoaded(true);
    }).catch((error)=>{
      console.log(error);
      alert("هذا الدرس غير موجود");
      navigate(-1);
    })
  },[courseId,id,lessonToEdit,navigate])

  useEffect(()=>{
    fetchData();
    setActive("المواد الدراسية");
    setMobileActive("courses mobile");
  },[reload])
  return (
    <div>
      {loaded &&(
        <div className="lesson-page">
          <div className="lesson-container">
            
            {/* Video + Details */}
            <div className="lesson-grid">
              {/* Video Section */}
                <iframe
                  className="lesson-video"
                  title="الدرس"
                  controlsList="nodownload"
                  controls={true}
                  onContextMenu={(e) => e.preventDefault()}
                  src={lesson.url}
                  allowFullScreen
                  preload="metadata"
                />

              {/* Lesson Info */}
              <div className="lesson-info">
                <h1 className="lesson-title">اسم الدرس: {lesson.lessonName}</h1>

                <p><span className="label">التصنيف: </span>{lesson.category}</p>
                <p><span className="label">الصف : </span>{lesson.year}</p>
                <p><span className="label">الفصل : </span>{lesson.term}</p> {/* term */}
                <p><span className="label">المادة : </span>{lesson.courseName}</p> {/* course name */}
                <p><span className="label">اسم الوحدة: </span>{lesson.unitName}</p>
                <p><span className="label">الناشر : </span>{lesson.uploader}</p>
                <p><span className="label">تاريخ النشر : </span>{lesson.date}</p>
                <p><span className="label">عدد مرات الشراء : </span>{lesson.timesBuying}</p>
                <p><span className="label">السعر : </span>{lesson.price}</p>
                {/* Buttons */}
                <div className="lesson-actions">
                  <button className="btn btn-delete" onClick={()=>{setShowDeleteLessonForm(true)}}>حذف</button>
                  <button className="btn btn-update" onClick={()=>{setShowEditLessonFrom(true)}}>تحديث</button>
                  <button className="btn btn-update" onClick={()=>{setShowQRPopup(true)}}>QR أكواد</button>
                  <button className="btn btn-update" onClick={async ()=>{
                    const dataList = await getListOfOldCodes();
                    if(dataList.length === 0){
                      setIsOldCodes(false);
                      return;
                    }
                    navigate(`/admin-home/lesson/qr-codes/${id}`, {state:{lessonName: lesson.lessonName, dataList}})}}>قديمة QR أكواد</button>
                  <button className="btn btn-update" style={{display:`${lesson.price === 0?"none":"block"}`}} onClick={()=>{setShowCodePopup(true)}}>احصل علي كود</button>
                  <button className="btn btn-update" style={{display:`${lesson.price === 0?"none":"block"}`}} disabled={getCodes} onClick={()=>{downloadUnusedCodes();}}>{getCodes?  "⏳" : 'أكواد قديمة'}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showEditLessonFrom&&(
                    <div className="overlay">
                    <div className="add-new-lesson-form">
                        <h3>تعديل الدرس</h3>
                        <label>عنوان الدرس</label>
                        <input type="text" 
                        dir="rtl"
                        lang="ar"
                        value={lessonToEdit.lessonName}
                        className={showWarning?"wrong-field": ""}
                        onChange={(e)=>{setLessonToEdit({...lessonToEdit, lessonName: e.target.value});setShowWarning(false);setWarngin("")}}/>
                        {showWarning && (<p className="warning">{warning}</p>)}
                        <label>السعر</label>
                        <input type="number"
                        value={lessonToEdit.price}
                        onChange={(e)=>{setLessonToEdit({...lessonToEdit,price: e.target.value})}} />

                        <button className="add-new-folder-button" onClick={updateLesson}>تعديل</button>
                        <button className="add-new-folder-button" onClick={()=>{setShowEditLessonFrom(false);setReload(!reload)}}>إلغاء</button>
                    </div>
                    </div>
                )}

                {showDeleteLessonForm &&(
                    <div className="overlay">
                    <div className="delete-lesson-folder-unit-form">
                        <div>
                            <h3>حذف الدرس</h3>
                            <p>هل انت متأكد أنك تريد حذف هذا الدرس؟</p>
                            <p>{lessonToEdit.name}</p>
                            </div>
                        <div className="lesson-delete-buttons">
                        <button className="lesson-delete-button" onClick={deleteLesson}>نعم</button>
                        <button onClick={()=>setShowDeleteLessonForm(false)}>لا</button>
                    </div>
                    </div>
                    </div>

                )}

                {showCodesPopup&&(
                  <div className="overlay">
                    <div className="delete-lesson-folder-unit-form codes-div">
                      <h3 className="get-code-h3">الحصول علي اكواد جديدة</h3>
                      <h5 className="lesson-name" style={{textAlign:"right"}}>اسم الدرس: {lesson.lessonName} </h5>
                      <div>
                      <input type="number" dir="rtl" value={codesToGenerate} onChange={(e)=>setCodesToGenerate(e.target.value)} />
                      <label className="number-of-codes-lable">عدد الاكواد</label>
                      </div>
                      <div style={{display:"flex",justifyContent:"space-around"}}>
                        <button style={{width:"fit-content",padding:"5px", fontSize:"medium"}} onClick={()=>{setShowCodePopup(false);setCodesToGenerate(0)}}>إغلاق</button>
                        <button style={{width:"fit-content",padding:"5px", fontSize:"medium"}} onClick={downloadCodes}>{getCodes? "⏳": 'احصل على الاكواد'}</button>
                      </div>
                    </div>
                  </div>
                )}

                {showQRPopup&&(
                  <div className="overlay">
                    <div className="delete-lesson-folder-unit-form codes-div">
                      <h3 className="get-code-h3">QR الحصول علي اكواد</h3>
                      <h5 className="lesson-name" style={{textAlign:"right"}}>اسم الدرس: {lesson.lessonName} </h5>
                      <div>
                      <input type="number" dir="rtl" value={codesToGenerate} onChange={(e)=>setCodesToGenerate(e.target.value)} />
                      <label className="number-of-codes-lable">عدد الاكواد</label>
                      </div>
                      <div style={{display:"flex",justifyContent:"space-around"}}>
                        <button style={{width:"fit-content",padding:"5px", fontSize:"medium"}} onClick={()=>{setShowQRPopup(false);setCodesToGenerate(0)}}>إغلاق</button>
                        <button style={{width:"fit-content",padding:"5px", fontSize:"medium"}} onClick={async ()=>{
                            const dataList = await getListOfCodes();
                            navigate(`/admin-home/lesson/qr-codes/${id}`, {state:{lessonName: lesson.lessonName, dataList}})}}>{getCodes? "⏳": 'احصل على الاكواد'}</button>
                      </div>
                    </div>
                  </div>
                )}

                {capacityExceeded&&(
                <div className="overlay">
                
                  <div className="subscribe-form">
                    <h3>برجاء التجديد لمتابعة بيع الدروس</h3>
                    <div style={{display:"flex",justifyContent:"space-between",width:"100%",padding:"10px"}}>
                    <button onClick={()=>{setCapacityExceeded(false);}}>إلغاء</button>
                    <button onClick={()=>navigate("/admin-home/plans")}>خطط الاسعار</button>
                    </div>
                  </div>
                   </div>
                  )}

                  {!isOldCodes&&(
                <div className="overlay" style={{justifyContent:'center',display:"flex",alignItems:"center"}}>
                
                  <div className="no-used-codes-div">
                    <h3 style={{textAlign:"center"}}>لا يوجد اكواد قديمة</h3>
                    <div style={{display:"flex"
                      ,justifyContent:"center",width:"100%",padding:"10px"}}>
                    <button style={{padding:"10px"}} onClick={()=>{setIsOldCodes(true);}}>إغلاق</button>
                    </div>
                  </div>
                   </div>
                  )}

    </div>
  );
}
